module.exports = __webpack_public_path__ + "static/media/screenshot_history_4_en.4c404189.png";